import * as types from './types';

export function goToSection(sectionID) {
	return (dispatch) => {
		dispatch({
			type: types.GO_TO_SECTION,
			currentSection: sectionID,
		});
	}
}

export function goToGroup(groupID) {
	return (dispatch) => {
		//console.log('going to group in action', groupID);
		dispatch({
			type: types.GO_TO_GROUP,
			currentGroup: groupID,
		});
	}
}

export function goToStage(stageID) {
	return (dispatch) => {
		dispatch({
			type: types.GO_TO_STAGE,
			currentStage: stageID,
		});
	}
}

export function playImageSequence() {
	return (dispatch) => {
		dispatch({
			type: types.PLAY_IMAGE_SEQUENCE,
			imageSequenceIsPlaying: true,
		});
	};
}

export function stopImageSequence() {
	return (dispatch) => {
		dispatch({
			type: types.STOP_IMAGE_SEQUENCE,
			imageSequenceIsPlaying: false,
		});
	};
}

export function setNextImagesLoaded () {
	return (dispatch) => {
		dispatch({
			type: types.SET_NEXT_IMAGES_LOADED,
			nextImagesLoaded: true,
		});
	}
}

export function setNextVideoLoaded () {
	return (dispatch) => {
		dispatch({
			type: types.SET_NEXT_VIDEO_LOADED,
			nextVideoLoaded: true,
		});
	}
}

export function setMouseFrame(frame) {
	return (dispatch => {
		dispatch({
			type: types.SET_MOUSE_FRAME,
			mouseFrame: frame,
		});
	});
}

export function setModal(modalData) {
	return (dispatch => {
		dispatch({
			type: types.SET_MODAL,
			modal: modalData,
		});
	});
}

export function setOverlay(bool) {
	return (dispatch => {
		dispatch({
			type: types.SET_OVERLAY,
			overlay: bool,
		});
	});
}

export function setUnityDisplay(bool) {
  return dispatch => {
    dispatch({
      type: types.SET_UNITY_DISPLAY,
      unityDisplay: bool
    });
  };
}

export function setUnityProgress(percentage) {
  return dispatch => {
    dispatch({
      type: types.SET_UNITY_PROGRESS,
      unityProgress: percentage
    });
  };
}

export function callUnityScene(num) {
  return dispatch => {
    dispatch({
      type: types.CALL_UNITY_SCENE,
      unitySceneCalled: num
    });
  };
}

export function setLoader(bool) {
	return (dispatch => {
		dispatch({
			type: types.SET_LOADER,
			loader: bool,
		});
	});
}


export function requestNews(url) {
	return (dispatch) => {
		dispatch({
			type: types.REQUEST_NEWS,
			currentNews: null,
			loading: true
		});

		const cached = localStorage && localStorage['cached-news'] && JSON.parse(localStorage['cached-news']);
		if(cached && cached.date > (new Date().getTime() - (60000 * 1))) {
			dispatch(receiveNews(cached.data));
			return;
		}

		return fetch(url)
			.then(
				response => response.json(),
				error => dispatch(receiveNewsError(error))
			)
			.then(json =>
				(json && 
				(localStorage['cached-news'] = JSON.stringify({ date: (new Date()).getTime(), data: json })) &&
				dispatch(receiveNews(json)))
				||
				(localStorage['cached-news'] && 
				dispatch(receiveNews(JSON.parse(localStorage['cached-news']).data)))
			);
	}
}

export function receiveNews(news) {
	return (dispatch) => {
		dispatch({
			type: types.RECEIVE_NEWS,
			loading: false,
			news: news,
			//currentNews: (news && news[0] && news[0]._id)
		});
	}
}

export function receiveNewsError(error) {
	return (dispatch) => {
		console.log('got news error', typeof error, error);
		dispatch({
			type: types.RECEIVE_NEWS_ERROR,
			loading: false,
			error: error
		});
	}
}

export function goToNews(newsId) {
	return (dispatch) => {
		dispatch({
			type: types.GO_TO_NEWS,
			currentNews: newsId,
		});
	}
}


export function goToCategory(category) {
	return (dispatch) => {
		dispatch({
			type: types.GO_TO_CATEGORY,
			currentCategory: category,
		});
	}
}


export function goToSolution(solution) {
	return (dispatch) => {
		dispatch({
			type: types.GO_TO_SOLUTION,
			currentSolution: solution,
		});
	}
}



export function goToContentType(contentType) {
	return (dispatch) => {
		//console.log('in goToContentType', goToContentType, contentType)
		dispatch({
			type: types.GO_TO_CONTENTTYPE,
			currentContentType: contentType,
		});
	}
}


export function setCheckedApps(appsObj) {
	return (dispatch) => {
		//console.log('in setCheckedApps', appsObj)
		dispatch({
			type: types.SET_CHECKEDAPPS,
			checkedApps: appsObj,
		});
	}
}



// WEBPACK FOOTER //
// ./src/actions/index.js